module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1r3n6r-2880e740a785f93da309317d014b6583.svg";